import Swiper from 'swiper/swiper-bundle.esm.browser.min.js';

class HpHero {
    constructor($hero) {
        this.$hero = $hero;
        this.$slider = $hero.querySelector('.hp-hero-slider');
        this.$dotsWrap = $hero.querySelector('.hp-hero-dots');
        this.$dots = $hero.querySelectorAll('.hp-hero-dot');

        this.init();
        this.events();
    }

    init() {
        this.autoplay = true;

        this.slider = new Swiper(this.$slider, {
            watchOverflow: true,
            keyboard: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            a11y: {
                'prevSlideMessage': 'Poprzedni slajd',
                'nextSlideMessage': 'Następny slajd',
                'firstSlideMessage': 'To jest pierwszy slajd',
                'lastSlideMessage': 'To jest ostatni slajd',
                'paginationBulletMessage': 'Idź do slajdu numer {{index}}'
            },
            // wrapperClass: 'slides',
            // slideClass: 'slide'
            slidesPerView: 1,
            loop: false,
            autoplay: {
                delay: 10000 // 10 sek.
            },
            navigation: {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            },
            pagination: {
                el: '.slider-pagination',
                type: 'bullets',
                clickable: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                paginationRender: this.fixPagination.bind(this),
                transitionStart: this.changeSlide.bind(this)
            }
        });

        this.changeSlide();

        setTimeout(this.changeSlide.bind(this), 300);
    }

    events() {
        for (let $dot of this.$dots) {
            $dot.addEventListener('click', () => {
                let id = $dot.dataset['id'];

                this.slider.slideTo(id);
                // setTimeout(() => this.slider.slides[id].focus(), 100);
            });
        }

        this.$hero.querySelector('.hp-hero-toggle-autoplay').addEventListener('click', e => {
            let $btn = e.target;

            if (this.autoplay) {
                this.slider.autoplay.stop();
                $btn.innerText = $btn.dataset.off;
            } else {
                this.slider.autoplay.start();
                $btn.innerText = $btn.dataset.on;
            }

            this.autoplay = !this.autoplay;
        });

        this.$slider.addEventListener('mouseenter', this.pause.bind(this));
        this.$slider.addEventListener('mouseleave', this.resume.bind(this));
        this.$slider.addEventListener('focusin', this.pause.bind(this));
        this.$slider.addEventListener('focusout', this.resume.bind(this));
    }

    pause() {
        if (this.autoplay) {
            this.slider.autoplay.stop();
        }
    }

    resume() {
        if (this.autoplay) {
            this.slider.autoplay.start();
        }
    }

    fixPagination(swiper) {
        for (let i in swiper.pagination.bullets) {
            if (swiper.pagination.bullets.hasOwnProperty(i)) {
                let $b = swiper.pagination.bullets[i];

                $b.addEventListener('click', e => {
                    setTimeout(() => { this.slider.slides[i].querySelector('.hp-hero-content-inner').focus(); }, 300);
                });
            }
        }
    }

    changeSlide() {
        let $activeDot = this.$dotsWrap.querySelector('.active'),
            $dot = this.$dotsWrap.querySelector(`[data-id="${this.slider.activeIndex}"]`);

        if ($activeDot) {
            $activeDot.classList.remove('active');
        }
        $dot.classList.add('active');

        this.$dotsWrap.style.minHeight = this.slider.visibleSlides[0].querySelector('.hp-hero-content').getBoundingClientRect().height + 'px';

    }
}

export default HpHero;
